import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Browser from '@wetransfer/concorde-browser';

import { AppConfig } from '../../../core-bundle/config/app-config';
import { verify as verifyAction } from '../../../transfer-bundle/store/actions';

import I18n from '@module/i18n';
import Analytics from '@module/analytics';
import Actions from '@app/action';

import Icon from '@component/icon';
import Illustration from '@component/illustration';
import { getIsForwardedTransfer } from '@app/transfer-bundle/store/selectors';

export class Verify extends React.Component {
  state = {
    token: '',
  };

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.verify = this.verify.bind(this);
  }

  async verify() {
    const { verify, isForwardedTransfer } = this.props;

    try {
      await verify({
        token: this.state.token,
        isForwardedTransfer,
      });
    } catch (error) {
      // do nothing
    }

    Analytics.trackStructEvent({
      category: 'transfer_verification',
      action: 'click_start_transfer',
    });
  }

  onChange(e) {
    this.setState({ token: e.target.value });
  }

  createOnEnter = (event) => {
    if (event.key === 'Enter') {
      this.props.create();
    }
  };

  handleBackButtonClick = () => {
    Analytics.trackStructEvent({
      category: 'transfer_verification',
      action: 'click_back',
    });

    this.props.create();
  };

  render() {
    const contents = (
      <div className="transfer__contents">
        <Illustration type="transfer-password" className="uploader__image" />
        <h2>{I18n.t('transfer.verify.title')}</h2>
        <p className="complete__text">{I18n.t('transfer.verify.text')}</p>
        <input
          type={Browser.isMobile ? 'number' : 'text'}
          maxLength={AppConfig.transfer.verificationCodeLength}
          name="transfer_token"
          placeholder={I18n.t('transfer.verify.verification-code')}
          className="transfer__textfield"
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
        />
      </div>
    );

    const buttonClassnames = ['transfer__button'];

    if (this.state.token.length !== AppConfig.transfer.verificationCodeLength) {
      buttonClassnames.push('transfer__button--inactive');
    }

    const button = (
      <button className={buttonClassnames.join(' ')} onClick={this.verify}>
        {I18n.t('transfer.verify.button')}
      </button>
    );

    return (
      <div className="transfer__window uploader uploader--complete">
        {contents}
        <div className="transfer__footer">
          <Icon
            type="TransferBack"
            className="transfer__back"
            onClick={this.handleBackButtonClick}
            onKeyDown={this.createOnEnter}
            label={I18n.t('transfer.buttons.go_to_transfer')}
          />
          {button}
        </div>
      </div>
    );
  }
}

Verify.propTypes = {
  create: PropTypes.func.isRequired,
  verify: PropTypes.func.isRequired,
  upload: PropTypes.func.isRequired,
  pushTransferNotification: PropTypes.func.isRequired,
  isForwardedTransfer: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isForwardedTransfer: getIsForwardedTransfer(state),
});

const mapDispatchToProps = {
  create: Actions.Transfer.create,
  verify: verifyAction,
  upload: Actions.Transfer.upload,
  pushTransferNotification: Actions.Notification.pushTransfer,
};

export default connect(mapStateToProps, mapDispatchToProps)(Verify);
